import { projectIconsAll } from "Assets/Constants";
import Button from "Components/Button";
import LoadingIcon from "Components/LoadingIcon";
import { ProjectIcon } from "Containers/CreateProjectContainer/styles";
import React, { Component } from "react";
import styled from "styled-components";
import { FormError, FormSuccess } from "Themes/StyledComponents";

const Container = styled.div``;

const ProjectIconsContainer = styled.div`
  display: flex;
  margin-top: 2.5%;
  justify-content: center;
  flex-wrap: wrap;
  border: ${props => (props.border ? "solid 2px lightgray" : "solid 2px gray")};
  border-radius: 5px;
  padding: 10px;
  overflow-x: auto;
  max-height: 250px;
`;

const ButtonContainer = styled.div`
  float: right;
  padding: 10px;
`;

class EditProjectImagesForm extends Component {
  state = {
    selectedIcon:
      this.props.projectIcon === 0 || !this.props.projectIcon
        ? 0
        : this.props.projectIcon - 1
  };

  handleSubmit = () => {
    const { handleSubmit } = this.props;
    handleSubmit(this.state.selectedIcon);
  };

  renderAllIcons = () => {
    return projectIconsAll.map((icon, key) => {
      let TagName = icon;
      return (
        <ProjectIcon
          key={key}
          onClick={() => this.setState({ selectedIcon: key })}
          selectedIcon={this.state.selectedIcon === key}
        >
          <TagName fontSize={40} />
        </ProjectIcon>
      );
    });
  };

  render() {
    // const { selectedIcon } = this.state;
    const { border, error, success, fetching } = this.props;
    // const SelectedIcon = projectIconsAll[selectedIcon];
    return (
      <Container>
        {/* <ProjectMainIcon>
          <SelectedIcon fontSize={40} />
        </ProjectMainIcon> */}
        <ProjectIconsContainer border={border}>
          {this.renderAllIcons()}
        </ProjectIconsContainer>
        {error && <FormError>Oops...there was an error</FormError>}
        {success && <FormSuccess>Project Updated!</FormSuccess>}
        <ButtonContainer>
          <Button type={"button"} onClick={this.handleSubmit}>
            {fetching ? <LoadingIcon /> : "Save"}
          </Button>
        </ButtonContainer>
      </Container>
    );
  }
}

export default EditProjectImagesForm;
